@if (showVersionMismatch) {
	<div class="version-mismatch-container">
		<div class="version-mismatch">
			<h3 class="version-mismatch-title">
				{{ 'common.version-mismatch-modal.title' | translate }}
			</h3>
			<p class="version-mismatch-text">
				{{ 'common.version-mismatch-modal.text' | translate }}
			</p>
			<button color="accent" mat-stroked-button (click)="refresh()">
				<mat-icon>refresh</mat-icon>
				{{ 'common.version-mismatch-modal.refresh' | translate }}
			</button>
		</div>
	</div>
}
